module.exports = __webpack_public_path__ + "static/media/Placaj ceramic Klinker Macao.ed907a6d.jpg";